import { TextInput } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { BeneficiaryType } from 'views/TerminateContract/TerminateForm/initialValues'

interface BeneficiaryPhoneNumberFieldProps {
  index: number
}

export const BeneficiaryPhoneNumberField: React.FC<
  BeneficiaryPhoneNumberFieldProps
> = ({ index }) => {
  return (
    <Field name={`beneficiaries[${index}]phoneNumber`}>
      {({ field, meta }: FieldProps<BeneficiaryType['phoneNumber']>) => (
        <FormFieldWrapper
          name={field.name}
          label={t('terminateContract:labels.phoneNumber')}
          className="min-tablet:flex-1"
          meta={meta}
          labelBold
        >
          <TextInput {...field} />
        </FormFieldWrapper>
      )}
    </Field>
  )
}
